import React from "react"

const Payment = () => {
    return (
        <>
        </>
    )
}

export default Payment;